import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { BlockScopingContextProvider } from "@geome/react-next/lib/context/blockScoping";
import { useCallback, useState } from "react";
import { TitleForSectionWithTitle } from "./title";
export const SectionWithTitle = (props) => {
    const { id, className, sectionTokenPath, children, available = true, withAnchorDiv = false, collapsible = false, } = props;
    const isCollapsible = Boolean(collapsible);
    const [open, setOpen] = useState(isInitiallyOpen(collapsible));
    const { translate } = useI18n();
    const titleId = `${id}-title`;
    const onTitleClick = useCallback(() => {
        if (isCollapsible) {
            const nextOpen = !open;
            setOpen(nextOpen);
            if (typeof collapsible === "object" && collapsible.onCollapseOrExpand) {
                collapsible.onCollapseOrExpand(nextOpen);
            }
        }
    }, [isCollapsible, open, collapsible]);
    return (_jsxs("section", { id: id, role: "region", "aria-labelledby": titleId, className: `section-with-title section-with-title--${id} ${className || ""}`, children: [withAnchorDiv && _jsx("div", { id: `${id}-anchor`, className: "section-with-title__anchor" }), _jsx(TitleForSectionWithTitle, { onClick: onTitleClick, open: open, ...props }), open && (_jsxs(_Fragment, { children: [!available && (_jsx("div", { className: "section-with-title__unavailable", children: translate(`${sectionTokenPath}.unavailable`) })), _jsx(BlockScopingContextProvider, { block: id, children: available && children })] }))] }));
};
const isInitiallyOpen = (collapsible) => {
    if (typeof collapsible === "object" && collapsible.openByDefault !== undefined)
        return collapsible.openByDefault;
    if (collapsible)
        return false;
    return true;
};
